import List from 'list.js';
var options = {
  valueNames: ['name',{ data: ['id'] }],

  page: 20,
  pagination: [
    {
      innerWindow: 5
    }
  ],

};

 var featureList = new List('down-list', options);

$('#filter-down-mirror').change(function () {

  var id = $(this).val();

  if(!id){
    featureList.filter()
    return true;
  }
  featureList.filter(function(item) {

    console.log( $(this).val())
    if(item._values.id == id){

      return true;
    }else{
      return false
    }
    return false
  });

})

$('.lang-change').change(function () {

  $(this).parents('li').find('.download a').attr('href',$(this).val())
})

$('body').on('change','.lang-change-ajax',function () {
  $(this).parents('.download-item').find('a.download').attr('href',$(this).val())
})



// WEBPACK FOOTER //
// ./scripts/routes/downloads.js